import { render, staticRenderFns } from "./AsiakasLaskutuksenYhteenveto.vue?vue&type=template&id=71eb82aa&scoped=true&"
import script from "./AsiakasLaskutuksenYhteenveto.vue?vue&type=script&lang=js&"
export * from "./AsiakasLaskutuksenYhteenveto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71eb82aa",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71eb82aa')) {
      api.createRecord('71eb82aa', component.options)
    } else {
      api.reload('71eb82aa', component.options)
    }
    module.hot.accept("./AsiakasLaskutuksenYhteenveto.vue?vue&type=template&id=71eb82aa&scoped=true&", function () {
      api.rerender('71eb82aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AsiakasLaskutuksenYhteenveto.vue"
export default component.exports